/** Everyone in a space (owner first) except `meId`. */
export function othersInSpace<T extends { id: string }>(
  space: { owner: T; members: T[] },
  meId: string | undefined,
): T[] {
  return [space.owner, ...space.members].filter((person) => person.id !== meId);
}

/** "With Ana, Ben", or "Just you so far" for a space nobody else is in. */
export function spacePeopleLabel(
  space: { owner: { id: string; name: string }; members: { id: string; name: string }[] },
  meId: string | undefined,
): string {
  const others = othersInSpace(space, meId);
  return others.length === 0 ? 'Just you so far' : `With ${others.map((p) => p.name).join(', ')}`;
}

/** How an account is shown under its name: "@ana", or "Guest" for guests. */
export function accountLabel(user: { username: string | null; isGuest: boolean }): string {
  return user.username ? `@${user.username}` : 'Guest';
}
